export const validateFormOnFrontend = () => {

  var emailInput = document.querySelector('.gform_wrapper form input[type="email"]');

  if (!emailInput) {
    return;
  }

  emailInput.addEventListener('blur', function() {
    const email = this.value;
    const translations = assecolp?.translations;
    
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zAZ]{2,6}$/;
    const validationContainer = document.querySelector('.gform_wrapper form .gfield_validation_message');
    const parent = emailInput.closest('.gfield--type-email');
    
    if (!parent) {
      return;
    }
    
    const error = document.createElement('div');
    error.classList.add('gfield_validation_message', 'gfield_description', 'validation_message');

    error.innerHTML = `<p>${translations?.requested_format}</p><p class="format-info">${translations?.email_validation}</p>`;
    
    if (!emailPattern.test(email) && email) {
      parent.appendChild(error);
    } else {
      if (validationContainer) {
        parent.removeChild(validationContainer);
      }
    }
  });
}
